<template>
  <div class="row">
    <div class="col-12">
      <Heading>Flaschen hinzufügen</Heading>
      <form class="border border-light p-5" @submit.prevent="save">
        <div class="row align-items-end mb-3">
          <div class="col-sm-6 col-lg-3">
            <data-input label="Lieferdatum"
                        type="date"
                        v-model="date"
            />
          </div>
          <div class="col-sm-6 col-lg-3">
            <data-input label="Lieferzeit"
                        type="time"
                        v-model="time"
            />
          </div>
        </div>
        <div v-for="(bottle, idx) in bottles" class="row align-items-end">

          <div class="col-11">
            <div class="row">
              <div class="col-4">
                <b class="text-primary">Flaschennummer:</b><br>
                <data-input required v-model="bottle.serial"/>
              </div>
              <div class="col-4">
                <b class="text-primary">Flaschentyp:</b><br>
                <data-select required :options="bottleTypes" v-model="bottle.type"/>
              </div>
              <div class="col-4">
                <b class="text-primary">Fällig:</b><br>
                <data-input required :value="dateWithFormat(bottle.due, 'YYYY-MM-DD')"
                            @input="setNewDate(bottle, $event)"
                            type="date"/>
              </div>
            </div>
          </div>
          <div class="col-1">
            <button type="button"
                    class="btn btn-danger mb-1"
                    :disabled="bottles.length === 1"
                    @click="removeFromList(idx)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
          <div class="col-12">
            <hr>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-primary btn-sm px-4" @click="addEmptyBottle">
              <i class="fas fa-plus"></i> Weitere Flasche
            </button>
          </div>
          <div class="col-3 offset-6 text-right">
            <button type="button" @click="cancel" class="btn btn-secondary btn-block mt-5 btn-sm">Abbrechen</button>
          </div>
          <div class="col-3 text-right">
            <button class="btn btn-primary btn-block mt-5 btn-sm">Falschen hinzufügen</button>
          </div>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment'
import SearchBar from "../../components/admin/SearchBar";
import Heading from "../../components/admin/Heading";
import {mapActions, mapGetters, mapState} from "vuex";
import BottleState from "../../components/admin/BottleState";
import timeFormatter from "../../mixins/timeFormatter";
import BottleActionLog from "../../components/admin/BottleActionLog";
import DataInput from "../../components/DataInput";
import DataSelect from "../../components/DataSelect";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

const EMPTY_BOTTLE = {
  serial: '',
  type: '',
  due: ''
}

export default {
  name: "BottleAdd",
  components: {DataSelect, DataInput, BottleActionLog, BottleState, Heading, SearchBar},
  mixins: [timeFormatter],
  data() {
    return {
      date: dayjs().format('YYYY-MM-DD'),
      time: dayjs().format('HH:mm:ss'),
      bottles: [{
        serial: '',
        type: '',
        due: '',
        date: ''
      }],
    }
  },
  computed: {
    ...mapState({
      bottleTypes: state => state.bottleTypes
    }),
    ...mapGetters({
      getLatestActionId: "getLatestActionId"
    })
  },
  methods: {
    ...mapActions({
      fetchBottleDetails: "Api/Bottles/get",
      enteredStorage: "Api/Bottles/entered_storage"
    }),
    setNewDate(bottle, date) {
      Vue.set(bottle, 'due', moment.parseZone(date).toISOString());
    },
    addEmptyBottle() {
      let bottleCopy = null;

      if (this.bottles.length > 0) {
        bottleCopy = JSON.parse(JSON.stringify(this.bottles[this.bottles.length - 1]))
      } else {
        bottleCopy = EMPTY_BOTTLE
      }

      this.bottles.push(Object.assign({}, bottleCopy, {serial: ''}))
    },
    removeFromList(idx) {
      this.bottles.splice(idx, 1)
    },
    save() {
      let [hour, minute, second] = this.time.split(':')
      let date = dayjs(this.date).hour(hour).minute(minute).second(second).local().format(this.$config.API_DATE_TIME_FORMAT)

      let bottles = this.bottles.map(bottle => {
        return {
          ...bottle,
          date
        }
      });
      this.enteredStorage({bottles})
          .then(result => this.$router.back())
          .catch(this.apiErrorHandler)
    },
    cancel() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>

</style>
